import { render, staticRenderFns } from "./NavGroupOrder.vue?vue&type=template&id=50469049&"
import script from "./NavGroupOrder.vue?vue&type=script&lang=ts&"
export * from "./NavGroupOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports